// extracted by mini-css-extract-plugin
module.exports = {"spinnerContainer":"LoaderSpinnerKit_spinnerContainer__3o9nU","spinner":"LoaderSpinnerKit_spinner__eNxSF","tag":"LoaderSpinnerKit_tag__mp20T"};